import {ok} from 'assert'

const assert = (value: boolean|(() => boolean), message?: string) => {
  ok(typeof value === 'function' ? value() : value, message)
}

export {assert}
